<template>
    <v-form v-model="valid" ref="form">
        <v-container fluid>
            <div class="headline">{{__('labels.traveling_expense')}}</div>
            <s-traveling-expense-field
                    :data="travelingExpenses.train"
                    :label="__('invoices.train')"
                    :rules="rules.train"
            >
            </s-traveling-expense-field>
            <s-traveling-expense-field
                    :data="travelingExpenses.plane"
                    :label="__('invoices.plane')"
                    :rules="rules.plane">
            </s-traveling-expense-field>
            <v-layout wrap>
                <v-flex xs12 md6>
                    <s-number-field
                            v-model="travelingExpenses.car.km"
                            :label="__('invoices.car_km')"
                            :rules="rules.car_km"
                            @input="updateCarNetto"
                    >
                    </s-number-field>
                </v-flex>
                <v-flex xs12 md6>
                    <s-price-field
                            v-model="travelingExpenses.car.netto"
                            :label="__('invoices.netto_sum') + ' ' + __('invoices.car')"
                            readonly
                            disabled
                            hint="0,30 €/km"
                    >
                    </s-price-field>
                </v-flex>
            </v-layout>
            <s-traveling-expense-field
                    :data="travelingExpenses.bus"
                    :label="__('invoices.bus')"
                    :rules="rules.bus">
            </s-traveling-expense-field>
            <s-traveling-expense-field
                    :data="travelingExpenses.taxi"
                    :label="__('invoices.taxi')"
                    :rules="rules.taxi">
            </s-traveling-expense-field>
            <s-traveling-expense-field
                    :data="travelingExpenses.parking"
                    :label="__('invoices.parking')"
                    :rules="rules.parking">
            </s-traveling-expense-field>
            <s-misc-traveling-expense-field v-for="(miscTravelingExpense, index) in miscTravelingExpenses"
                                            :misc="miscTravelingExpense"
                                            :key="index"
                                            :index="index"
            >
            </s-misc-traveling-expense-field>
            <v-btn
                    color="primary"
                    @click="addMiscTravelingExpense"
            >
                {{__('labels.add_misc_traveling_expense')}}
            </v-btn>
            <v-layout wrap>
                <v-flex xs12>
                    <s-price-field
                            :value="expensesSum"
                            :label="__('invoices.travel_sum') + (taxes==='19' ? ' ' + __('invoices.netto') : '')"
                            readonly
                    >
                    </s-price-field>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex shrink>
                    <button-previous></button-previous>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex shrink>
                    <button-next @click="nextButtonClick()"></button-next>
                </v-flex>
            </v-layout>
        </v-container>
    </v-form>
</template>

<script>
    import {mapState} from 'vuex'
    import {mapMutations} from 'vuex'
    import {mapActions} from 'vuex'
    export default {
        name: "TravelingExpensesStep",
        computed: {
            ...mapState('form',[
                'travelingExpenses',
                'miscTravelingExpenses',
                'taxes',
                'royalties'
            ]),
            expensesSum: {
                get() {
                    return this.$store.state.form.expensesSum;
                },
                set(v) {
                    this.$store.commit('form/setExpensesSum', v);
                }
            },
        },
        data() {
            return {
                valid: false,
                sum: 0,
                rules: this.$validation.create({
                        train: [],
                    }
                )
            }
        },
        methods: {
            updateCarNetto() {
                this.travelingExpenses.car.netto =  this.travelingExpenses.car.km * 30;
                this.travelingExpenses.car.brutto =  this.travelingExpenses.car.netto;
                this.calculateSum();
            },
            ...mapMutations('stepper', [
                'nextStep',
            ]),
            ...mapActions('form', [
                'setError',
                'calculateSum'
            ]),
            ...mapMutations('form', [
                'addMiscTravelingExpense',
            ]),
            nextButtonClick() {
                if (this.$refs.form.validate()) {
                    if(!this.expensesSum && !this.royalties) {
                        this.setError(this.__('messages.royalty_or_traveling_invalid'));
                    } else {
                        this.$cookies.set('travelingExpenses', this.travelingExpenses);
                        this.$cookies.set('miscTravelingExpenses', JSON.stringify(this.miscTravelingExpenses));
                        this.nextStep();
                    }
                } else {
                    this.setError(this.__('messages.form_invalid'));
                }
            },
        },
    }
</script>

<style scoped>

</style>